import { useAppSelector } from "@/stores/hook";
import StageDrawerRoute from "./components/StageDrawerRoute";
import ChildDetails from "./education/nicheSideRoutes/components/education-details/ChildDetails";
import VideoProductionChildDetails from "./videoProduction/nicheSideRoutes/components/video-details/VideoProductionChildDetails";
import AcademyChildDetails from "./academy/nicheSideRoutes/components/academy-details/AcademyChildDetails";
import useCurrentIndustry from "@/hooks/globalapis/useCurrentIndustry";

function ChildDetailsResolver() {
  const { industry } = useCurrentIndustry();

  if (industry?.id === 4) {
    return <VideoProductionChildDetails />;
  }

  if (industry?.id === 5) {
    return <AcademyChildDetails />;
  }

  return <ChildDetails />;
}

export default function DynamicStageDrawerIndexeIndex() {
  const { isStageViewOverride } = useAppSelector(
    (state) => state.childFunctional
  );

  return (
    <div className="m-4">
      {!isStageViewOverride && <StageDrawerRoute />}
      {isStageViewOverride && <ChildDetailsResolver />}
    </div>
  );
}
